export class DataNotLoaded extends Error {
    constructor(message?: string) {
        super(message);
    }
}

export class DataNotFound extends Error {
    constructor(message?: string) {
        super(message);
    }
}